import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import classes from "./bookingController.module.css";
import BookingCard from "../BookingCard";
import { ArrowForward } from "@mui/icons-material";
import { ArrowBack } from "@mui/icons-material";
import { useSelector } from "react-redux";

const BookingController = ({ status }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [highlightedIndex, setHighLightedIndex] = useState(null);
  const [unavailabilityDate, setUnavailabilityDate] = useState("");
  const [filterValue, setFilterValue] = useState("Upcoming");

  const { bookings } = useSelector((state) => state.booking);
  const itemsPerPage = 5;
  const offset = currentPage * itemsPerPage;
  const currentItems = bookings.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(bookings.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleRescheduleClick = (appointment, id) => {
    setHighLightedIndex(id);
    setSelectedAppointment(appointment);
  };

  useEffect(() => {
    let filterObj = {
      filter: filterValue,
    };
    // dispatch(fetchAppointments(filterObj));
  }, [filterValue, unavailabilityDate]);

  return (
    <>
      <div className={classes.outerMostContainer}>
        <div>
          <div className={classes.outerMostContainer}>
            {currentItems?.length > 0 ? (
              <div>
                {currentItems.map((appointment, index) => (
                  <BookingCard appointment={appointment} status={status} />
                ))}
              </div>
            ) : (
              <div className={classes.noBookingsContainer}>
                <p className={classes.noBookingsText}>
                  No bookings available for this status.
                </p>
              </div>
            )}

            {pageCount > 0 && (
              <ReactPaginate
                previousLabel={
                  <span
                    className={classes.paginateNavigateBtn}
                    style={{ textDecoration: "none" }}
                  >
                    <ArrowBack fontSize="medium" />
                    Previous
                  </span>
                } // Adding a left arrow
                nextLabel={
                  <span>
                    Next <ArrowForward fontSize="medium" />
                  </span>
                } // Adding a right arrow
                breakLabel={"..."}
                breakClassName={classes.breakMe}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={classes.pagination}
                pageClassName={classes.pageItem}
                pageLinkClassName={classes.pageLink}
                previousClassName={classes.pageItem}
                previousLinkClassName={classes.previousLink}
                nextClassName={classes.pageItem}
                nextLinkClassName={classes.nextLink}
                activeClassName={classes.active}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingController;
